/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ListAzureSubnets200ResponseSubnetsInner } from '../models/ListAzureSubnets200ResponseSubnetsInner';

export class ListAzureSubnets200Response {
  /**
  * The list of subnets
  */
  'subnets': Array<ListAzureSubnets200ResponseSubnetsInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "subnets",
      "baseName": "subnets",
      "type": "Array<ListAzureSubnets200ResponseSubnetsInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAzureSubnets200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

